import { Component, OnInit, inject, ChangeDetectionStrategy, input } from '@angular/core';
import { ViewportScroller, NgClass } from '@angular/common';

import { ContractDetailsService } from 'src/app/shared/services/contract-details.service';
import { ContractStatusTracker, FundsReceivedMoneyIn, Reg60TrackerStep, SourceOfFundsUI, TrackerChevron } from 'src/app/shared/models/app.model';
import { TrackerChevronValue } from 'src/config/constants';
import { AnalyticsAppService } from 'src/app/shared/services/analytics.service';
import { CustomDatePipe } from '../../shared/pipes/app.pipes';

@Component({
    selector: 'app-tracker-step',
    templateUrl: './tracker-step.component.html',
    styleUrls: ['./tracker-step.component.scss'],
    imports: [NgClass, CustomDatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TrackerStepComponent implements OnInit {
  private readonly viewportScroller = inject(ViewportScroller);
  private readonly contractDetailsService = inject(ContractDetailsService);
  private readonly analytics = inject(AnalyticsAppService);


  readonly step = input.required<ContractStatusTracker | Reg60TrackerStep>();
  readonly SourceOfFundsUI = input<SourceOfFundsUI[]>();
  readonly FundsReceivedMoneyIn = input<FundsReceivedMoneyIn[]>();

  trackerChevron: TrackerChevron = TrackerChevronValue;
  readonly notNoLOA = input<boolean>();
  readonly mobileView = input<boolean>(false);

  ngOnInit(): void {
    this.viewportScroller.setOffset(() => [0, 150]);
  }

  scrollTo(elementId: string, selectedStep: string): void {
    this.viewportScroller.scrollToAnchor(elementId);
    this.contractDetailsService.setLicensingViewLinkClick(true);
    this.analytics.logAnalytics({
      event_action: 'link',
      event_name: selectedStep,
      event_type: 'pending tool - annuity',
      event_version: 'case tracker'
    })
  }

  getAriaLabelValue(): string {
    const status = this.step()?.ChevronStatus;
    const name = this.step()?.TrackerChevron;

    if (status === 'Completed') {
      return `${name} chevron with status completed,  `;
    }
    if (status === 'Alert') {
      return `${name} chevron with status alert,  `;
    }
    return `${name} chevron with status pending,  `;
  }

  truncateText(): string {
    const step = this.step();
    const mobileView = this.mobileView();
    const trackerChevron = step?.TrackerChevron || '';
 
    if (mobileView && trackerChevron.includes('- Additional Requirement')) {
        return trackerChevron.replace('Requirement', 'Req');
    }
 
    return trackerChevron;
  }

}
